<template>
  <div class="no-service">
    <no-existing-resource
      :show-content="(emailHelp || phoneHelp)"
    >
      <template v-slot:title>
        {{ $t('no_existing_resource.service.title') }}
      </template>
      <template v-slot:explanation>
        {{ $t('no_existing_resource.service.explanation') }}
      </template>
      <div class="columns">
        <div class="column column-content">
          <div class="service-item">
            <progressive-background
              :src="hiresWebImage"
              :placeholder="thumbnailWebImagePath"
              data-test="backgroundImage"
              class="blue card"
              no-ratio
            >
              <div slot="content">
                <div class="columns">
                  <div class="column service-info">
                    <p class="is-size-1 is-size-3-touch has-text-weight-bold">
                      {{ $t('no_existing_resource.support') }}
                    </p>
                    <p class="is-size-1 is-size-3-touch has-text-weight-bold">
                      {{ phoneHelp }}
                    </p>
                  </div>
                  <div class="column service-info">
                    <p class="is-size-1 is-size-3-touch has-text-weight-bold">
                      {{ $t('no_existing_resource.sales') }}
                    </p>
                    <p class="is-size-1 is-size-3-touch has-text-weight-bold">
                      {{ emailHelp }}
                    </p>
                  </div>
                </div>
              </div>
            </progressive-background>
          </div>
        </div>
      </div>
    </no-existing-resource>
  </div>
</template>

<script>
import NoExistingResource from '@/components/Shared/NoExistingResource'

export default {

  name: 'NoService',

  components: {
    NoExistingResource
  },

  computed: {
    thumbnailImagePath () {
      return require('../assets/thumbnails/thumb_seo_background.jpg')
    },
    thumbnailWebImagePath () {
      return require('../assets/thumbnails/thumb_websites.jpg')
    },
    hiresWebImage () {
      return require('../assets/websites_greyscale.jpg')
    },
    hiresEmailImage () {
      return require('../assets/seo_background_greyscale.jpg')
    },
    hiresReportImage () {
      return require('../assets/dashboard_greyscale.jpg')
    },
    phoneHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('phone_number.help')
      }
      return this.$store.getters.brandConfigValue('phone_number', 'help')
    },
    emailHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('email.help')
      }
      return this.$store.getters.brandConfigValue('email', 'help')
    }

  }
}
</script>

<style lang="scss">
@import '../../sass/_variables.scss';
  .no-service {
    .progressive-background-slot {
      // position: absolute !important;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;
      height: 100%;

      * {
        position: relative;
      }

      &:before {
        content:'';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: .6 !important;
        transition: all 5s;
      }
    }

    .progressive-background {
      span > div {
        height: 100%;
      }
    }

    .blue .progressive-background-slot:before {
      background-color: var(--base-blue);
    }

    .purple .progressive-background-slot:before {
      background-color: var(--tertiary-color);
    }

    .base-purple .progressive-background-slot:before {
      background-color: var(--base-indigo);
    }

    .notification {
      height: 100%;
    }

  }

</style>
<style lang="scss" scoped>
@import '../../sass/_variables.scss';
.columns {
  align-items: stretch;
}
.column-content {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.service-item {
  flex: 1 1 auto;
  .service-body, .card {
    height: 100%;
    color: var(--base-white);
  }
}
.service-info {
  padding: 25px;
}
</style>
